import { cn } from '@/lib/ui/cn';
import { PropsWithChildren } from 'react';

type Props = PropsWithChildren & {
  className?: string;
};

export const BlogPagesShowOnDesktop: React.FC<Props> = ({
  children,
  className,
}) => <div className={cn('max-lg:hidden', className)}>{children}</div>;
